export default __webpack_public_path__ + "static/media/Advanced Potion Making - Spells_07.13c51879.jpg";